export enum Rating {
    Like = "thumbs_up",
    Dislike = "thumbs_down"
}